/** Catégories autorisées pour la bibliothèque numérique (e-learning). */
export const BIBLIOTHEQUE_CATEGORIES = [
  'Référence',
  'Veille',
  'Manuel',
  'Méthodologie',
  'Réglementation',
  'Étude de cas',
  'Article',
  'Ouvrage',
] as const;

export type BibliothequeCategory = (typeof BIBLIOTHEQUE_CATEGORIES)[number];
